/**
 * CRM page tabs: the default muted list blends into the page, so a darker
 * track and a brand-coloured active tab.
 */
export const CRM_TABS_LIST = "h-10 bg-titanium-100 dark:bg-muted";

export const CRM_TAB_TRIGGER =
	"px-3 text-muted-foreground hover:text-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground dark:data-[state=active]:bg-primary dark:data-[state=active]:text-primary-foreground";
